<template>
  <div class="new">
    <div class="title">
      <VTitle page-title="老师评语"></VTitle>
    </div>

    <div v-if="data.length" class="content">
      <VMessage  v-for="obj,index in data" :obj="obj" :key="index"></VMessage>

    </div>

    <div v-else class="nothing">
      您还没有评语噢~
    </div>




    <div>
      <VGoBackBtn></VGoBackBtn>
    </div>

  </div>
</template>

<script type="text/ecmascript-6">
  import VTitle from '../../components/VTitle.vue';
  import VMessage from '../../components/VMessage.vue';
  import VGoBackBtn from '../../components/VGoBackBtn.vue';
  import netTool from '../../api/netTool';

  export default {
    data () {
      return {
        data: []
      };
    },
    created () {
      this.getdata();
    },
    components: {VTitle, VMessage, VGoBackBtn},
    methods: {
      getdata () {
        let params = {
          'type': '2'
        };
        netTool.notice(params).then(response => {
          if (response.errno === '0') {
            this.data = response.result;
          } else {
            console.log(response.message);
          }
        })
          .catch(error => {
            console.log(error);
          });
      }
    }
  };
</script>

<style scoped lang="scss" type="text/scss" rel="stylesheet/scss">
  @import '../../assets/scss/base.scss';

  .new {
    width: px2rem(750);
    @include bg-img('../../assets/img/parentRecord/background');

    .nothing{
      height: px2rem(1334 - 240 - 161);
      box-sizing: border-box;
      padding: px2rem(60) ;
      font-size: px2rem(30);
      text-align: center;
    }
  }

  .title {
    padding-top: px2rem(40 + 49);
    text-align: center;
  }

  .content {
    padding-left: px2rem(50);
    width: px2rem(655);
    height: px2rem(1334 - 240 - 161);
    overflow-y: auto;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
  }
</style>



// WEBPACK FOOTER //
// TecComment.vue?bb855e48